import { render, staticRenderFns } from "./CreateOrEditSellerQuotation.vue?vue&type=template&id=3dd70ef3&scoped=true&"
import script from "./CreateOrEditSellerQuotation.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditSellerQuotation.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEditSellerQuotation.vue?vue&type=style&index=0&id=3dd70ef3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd70ef3",
  null
  
)

export default component.exports